export const DURATION_PATH = 11;
export const DURATION_LANDING = 3;
export const DURATION_ROTATION = 1.8;
export const DURATION_REVEAL = 2000;

export const ROTATION_DEG = 60;

export const DIRECTIONS = {
    left: 'left',
    right: 'right'
};

export const phrases = [
    {
        text: 'Все верно!',
        left: '80%',
        top: '18%'
    },
    {
        text: 'Так держать!',
        left: '25%',
        top: '20%'
    },
    {
        text: 'Ещё чуть-чуть',
        left: '76%',
        top: '16%',
        svgSizes: [153, 70],
        svg: <svg width="100%" height="100%" viewBox="0 0 153 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_f_64_210114)" data-figma-bg-blur-radius="6.84513">
        <path d="M128.487 34.5833C152.135 55.4173 107.359 46.7889 74.6861 51.5205C29.6035 54.4111 7.77001 46.4049 20.8853 34.5833C10.1708 21.2234 32.1223 15.2015 74.6861 17.6461C125.83 16.322 142.868 21.9243 128.487 34.5833Z" fill="white" fill-opacity="0.9"/>
        </g>
        <defs>
        <filter id="filter0_f_64_210114" x="-3.62396e-05" y="0.000452042" width="152.226" height="69.2257" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="8.55641" result="effect1_foregroundBlur_64_210114"/>
        </filter>
        <clipPath id="bgblur_0_64_210114_clip_path" transform="translate(3.62396e-05 -0.000452042)"><path d="M128.487 34.5833C152.135 55.4173 107.359 46.7889 74.6861 51.5205C29.6035 54.4111 7.77001 46.4049 20.8853 34.5833C10.1708 21.2234 32.1223 15.2015 74.6861 17.6461C125.83 16.322 142.868 21.9243 128.487 34.5833Z"/>
        </clipPath></defs>
        </svg>

    }
]